import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class AppComponent implements OnInit {
  private themeService = inject(ThemeService);
  private translateService = inject(TranslateService);

  ngOnInit(): void {
    this.themeService.initializeTheme();

    const storedLang = localStorage.getItem('app_language') ?? 'pt';
    this.translateService.setDefaultLang('pt');
    this.translateService.use(storedLang);
  }
}
